import { useContext, createContext } from 'react';
import { Pencil, Trash2, FileUp, Download, RotateCcw, RefreshCw, FolderInput } from 'lucide-react';

import { canRetry } from './documents-processing';
import { DocumentsItemMenu } from './documents-item-menu';

import type { ItemMenuAction } from './documents-item-menu';
import type { DocumentItem, DocumentBucket } from './documents-data';

export type FileActions = {
  bucket: DocumentBucket;
  onRename: (item: DocumentItem) => void;
  onMove: (item: DocumentItem) => void;
  onDownload: (item: DocumentItem) => void;
  onDelete: (item: DocumentItem) => void;
  onRestore: (item: DocumentItem) => void;
  onPurge: (item: DocumentItem) => void;
  onReplace: (item: DocumentItem) => void;
  onRetry: (item: DocumentItem) => void;
};

export const DocumentsFileActionsContext = createContext<FileActions | null>(null);

function fileMenuActions(item: DocumentItem, a: FileActions): ItemMenuAction[] {
  if (a.bucket === 'bin') {
    return [
      { key: 'restore', label: 'Restore', icon: <RotateCcw size={14} />, run: () => a.onRestore(item) },
      { key: 'purge', label: 'Delete permanently', icon: <Trash2 size={14} />, run: () => a.onPurge(item) },
    ];
  }
  const retry: ItemMenuAction[] = canRetry(item)
    ? [{ key: 'retry', label: 'Retry', icon: <RefreshCw size={14} />, run: () => a.onRetry(item) }]
    : [];
  return [
    ...retry,
    { key: 'download', label: 'Download', icon: <Download size={14} />, run: () => a.onDownload(item) },
    { key: 'rename', label: 'Rename', icon: <Pencil size={14} />, run: () => a.onRename(item) },
    { key: 'move', label: 'Move to…', icon: <FolderInput size={14} />, run: () => a.onMove(item) },
    { key: 'replace', label: 'Replace file…', icon: <FileUp size={14} />, run: () => a.onReplace(item) },
    { key: 'delete', label: 'Delete', icon: <Trash2 size={14} />, run: () => a.onDelete(item) },
  ];
}

export function DocumentsFileMenu({ item }: { item: DocumentItem }) {
  const actions = useContext(DocumentsFileActionsContext);
  if (!actions) return null;
  return <DocumentsItemMenu label="File actions" actions={fileMenuActions(item, actions)} />;
}
